module.exports = __webpack_public_path__ + "img/iconCircleArrow.7c569ce0.svg";